/* eslint-disable react-hooks/exhaustive-deps */
import ConfirmationModal from "components/ConfirmationModal";
import TabNav from "components/TabNav";
import { useToast } from "contexts/ToastContext";
import { useHasRole } from "contexts/AuthContext";
import AddAppealCouncilLitigationDecisionModal from "pages/appealRequests/fragments/AddAppealCouncilLitigationDecisionModal";
import AddAppealLitigationDecisionModal from "pages/appealRequests/fragments/AddAppealLitigationDecisionModal";
import AppealCouncilLitigationCard from "pages/appealRequests/fragments/AppealCouncilLitigationCard";
import AppealLitigationCard from "pages/appealRequests/fragments/AppealLitigationCard";
import TerminateAppealLitigationModal from "pages/appealRequests/fragments/TerminateAppealLitigationModal";
import AssignedProsecutorHistory from "pages/complaintRequest/fragments/AssignedProsecutorHistory";
import ChargeDocumentCardAdvocate from "pages/complaintRequest/fragments/ChargeDocumentCardAdvocate";
import ComplaintDetailInfoCard from "pages/complaintRequest/fragments/ComplaintDetailInfoCard";
import DecisionCard from "pages/complaintRequest/fragments/DecisionCard";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  editAccusedSummon,
  fetchAccusedAssignmentHistory,
  fetchAccusedSummonByComplaintId,
  fetchAppealCouncilLitigationByAppealSummonId,
  fetchAppealLitigationByAppealSummonId,
  fetchComplaintById,
  fetchCourtAppealByComplaintId,
  fetchInvestigationByComplaintId,
} from "services/prosecutorDecipilineService";
import {
  AccusedSummon,
  Complaints,
  CouncilLitigation,
  CourtAppeal,
  Investigation,
  Litigation,
} from "types";
import {
  ACCUSED_COMPLAINT_STATUS,
  COMPLIANT_STATUS,
  INVESTIGATION_STATUS,
} from "utils/constantValues";
import { ROLES } from "utils/roles";
import AccusedSummonCard from "./fragments/AccusedSummonCard";
import AddAccusedDailyHearingModal from "./fragments/AddAccusedDailyHearingModal";
import AppealToCourtModal from "./fragments/AppealToCourtModal";
import AddAccusedSummonModal from "pages/complaintRequest/fragments/AddAccusedSummonModal";
import { useTranslation } from "contexts/i18nContext";

export default function SingleAccusedForZonal() {
  const { uu_id } = useParams();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const canViewCompliantDetail = useHasRole([
    ROLES.INSPECTION_PROSECUTOR,
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
  ]);
  const canViewChargeDoc = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
    ROLES.INSPECTION_PROSECUTOR,
    ROLES.INSPECTION_REGISTRAR,
  ]);
  const canViewAccusedSummon = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
    ROLES.INSPECTION_PROSECUTOR,
    ROLES.INSPECTION_REGISTRAR,
    ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
    ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
    ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  ]);

  const canCreateInspectionDailyHearing = useHasRole([
    ROLES.INSPECTION_PROSECUTOR,
  ]);

  const isRegionalWriter = useHasRole([ROLES.REGIONAL_COUNCIL_OFFICE_WRITER]);
  const canCreateLitigationDecision = useHasRole([ROLES.INSPECTION_PROSECUTOR]);

  const canTerminateInspectionLitigation = useHasRole([
    ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canAppealToCourt = useHasRole([ROLES.INSPECTION_REGISTRAR]);
  const isRegionalCouncilHead = useHasRole([
    ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  ]);
  const canSendAccusedToRegistrar = useHasRole([ROLES.INSPECTION_PROSECUTOR]);
  const canViewAssignedHistory = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
  ]);

  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isDailyHearingOpen, setIsDailyHearingOpen] = useState(false);
  const [isLitigationDecisionOpen, setIsLitigationDecisionOpen] =
    useState(false);
  const [isCouncilLitigationDecisionOpen, setIsCouncilLitigationDecisionOpen] =
    useState(false);
  const [
    isCreateAccusedSummonForGeneralCouncil,
    setIsCreateAccusedSummonForGeneralCouncilOpen,
  ] = useState(false);
  const [isTerminateOpen, setIsTerminateOpen] = useState(false);
  const [isAppealCourtOpen, setIsAppealCourtOpen] = useState(false);
  const [isSendToRegistrar, setIsSendToRegistrar] = useState(false);
  const [isSendToCouncil, setIsSendToCouncil] = useState(false);

  const [complaintData, setComplaintData] = useState<
    Complaints | Complaints[]
  >();
  const [investigationData, setInvestigationData] = useState<Investigation>();
  const [allInvestigationData, setAllInvestigationData] =
    useState<Investigation[]>();
  const [accusedSummonData, setAccusedSummonData] = useState<AccusedSummon>();
  const [
    accusedSummonDataForGeneralCouncil,
    setAccusedSummonDataForGeneralCouncil,
  ] = useState<AccusedSummon>();
  const [appealLitigationData, setAppealLitigationData] =
    useState<Litigation[]>();
  const [
    appealLitigationDataForGenralCouncil,
    setAppealLitigationDataForGeneralCouncil,
  ] = useState<Litigation[]>();
  const [appealCouncilLitigationData, setAppealCouncilLitigationData] =
    useState<CouncilLitigation[]>();
  const [
    appealCouncilLitigationDataForGeneralCouncil,
    setAppealCouncilLitigationDataForGeneralCouncil,
  ] = useState<CouncilLitigation[]>();
  const [courtAppealData, setCourtAppealData] = useState<CourtAppeal>();
  const [assignmentHistoryData, setAssignmentHistoryData] = useState<any>();

  const tabs = [
    t("detailInformation"),
    accusedSummonData && t("appealToCouncil"),
    accusedSummonData?.registration_date && t("councilLitigation"),
    appealCouncilLitigationDataForGeneralCouncil && t("appealToGeneralCouncil"),
    accusedSummonDataForGeneralCouncil?.registration_date &&
      t("generalCouncilLitigation"),
  ].filter((tab): tab is string => Boolean(tab));
  const [activeTab, setActiveTab] = useState<string>(tabs[0]);

  const isNotFoundError = (error: any) => {
    const status =
      error?.response?.status ?? error?.status ?? error?.request?.status;
    return status === 404;
  };

  useEffect(() => {
    if (tabs.length > 0 && !tabs.includes(activeTab)) {
      setActiveTab(tabs[0]);
    }
  }, [tabs, activeTab]);

  const loadInitialPageData = async () => {
    if (!uu_id) {
      setIsInitialLoading(false);
      return;
    }

    setIsInitialLoading(true);

    try {
      const complaintRes = await fetchComplaintById(uu_id);
      const latestComplaint = Array.isArray(complaintRes)
        ? complaintRes?.slice()?.reverse()[0]
        : complaintRes;
      setComplaintData(latestComplaint);

      try {
        const investigationRes = await fetchInvestigationByComplaintId(uu_id);
        if (investigationRes) {
          const sortedInvestigations = investigationRes?.slice()?.reverse();
          setAllInvestigationData(sortedInvestigations);
          setInvestigationData(
            Array.isArray(investigationRes)
              ? sortedInvestigations[0]
              : investigationRes,
          );
        } else {
          setAllInvestigationData(undefined);
          setInvestigationData(undefined);
        }
      } catch (err) {
        if (isNotFoundError(err)) {
          setAllInvestigationData(undefined);
          setInvestigationData(undefined);
        } else {
          throw err;
        }
      }

      const accusedSummonRes = await fetchAccusedSummonByComplaintId(
        uu_id,
      ).catch((err) => {
        if (isNotFoundError(err)) return [] as AccusedSummon[];
        throw err;
      });

      const latestAccusedSummon = accusedSummonRes
        ?.slice()
        ?.reverse()
        ?.filter(
          (obj) =>
            obj.discipline_complain?.toString() === uu_id?.toString() &&
            obj?.is_appeal_to_general_council === false,
        )[0];

      const latestAccusedSummonForGeneralCouncil = accusedSummonRes
        ?.slice()
        ?.reverse()
        ?.filter(
          (obj) =>
            obj.discipline_complain?.toString() === uu_id?.toString() &&
            obj.is_appeal_to_general_council,
        )[0];

      setAccusedSummonData(latestAccusedSummon);
      setAccusedSummonDataForGeneralCouncil(
        latestAccusedSummonForGeneralCouncil,
      );

      const appealLitigationRes = await fetchAppealLitigationByAppealSummonId(
        uu_id || "",
      ).catch((err) => {
        if (isNotFoundError(err)) return [] as Litigation[];
        throw err;
      });

      setAppealLitigationData(
        appealLitigationRes
          ?.slice()
          ?.reverse()
          ?.filter(
            (obj) =>
              obj.summonappeal_accusepProsecutor === latestAccusedSummon?.id,
          ),
      );

      setAppealLitigationDataForGeneralCouncil(
        appealLitigationRes
          ?.slice()
          ?.reverse()
          ?.filter(
            (obj) =>
              obj.summonappeal_accusepProsecutor ===
              latestAccusedSummonForGeneralCouncil?.id,
          ),
      );

      const primaryCouncilLitigationRes = latestAccusedSummon?.id
        ? await fetchAppealCouncilLitigationByAppealSummonId(
            latestAccusedSummon.id,
          ).catch((err) => {
            if (isNotFoundError(err)) return [] as CouncilLitigation[];
            throw err;
          })
        : [];

      const generalCouncilLitigationRes =
        latestAccusedSummonForGeneralCouncil?.id &&
        latestAccusedSummonForGeneralCouncil?.id !== latestAccusedSummon?.id
          ? await fetchAppealCouncilLitigationByAppealSummonId(
              latestAccusedSummonForGeneralCouncil.id,
            ).catch((err) => {
              if (isNotFoundError(err)) return [] as CouncilLitigation[];
              throw err;
            })
          : primaryCouncilLitigationRes;

      const filteredPrimaryCouncilLitigation = primaryCouncilLitigationRes
        ?.slice()
        ?.reverse()
        ?.filter(
          (obj) =>
            obj.summonappeal_accusepProsecutor === latestAccusedSummon?.id,
        );

      const filteredGeneralCouncilLitigation = generalCouncilLitigationRes
        ?.slice()
        ?.reverse()
        ?.filter(
          (obj) =>
            obj.summonappeal_accusepProsecutor ===
            latestAccusedSummonForGeneralCouncil?.id,
        );

      setAppealCouncilLitigationData(
        filteredPrimaryCouncilLitigation.length > 0
          ? filteredPrimaryCouncilLitigation
          : undefined,
      );

      setAppealCouncilLitigationDataForGeneralCouncil(
        filteredGeneralCouncilLitigation.length > 0
          ? filteredGeneralCouncilLitigation
          : undefined,
      );

      const courtAppealRes = await fetchCourtAppealByComplaintId(uu_id).catch(
        (err) => {
          if (isNotFoundError(err)) return [] as CourtAppeal[];
          throw err;
        },
      );

      setCourtAppealData(
        courtAppealRes
          ?.slice()
          ?.reverse()
          ?.filter((obj) => obj.discipline_complain === uu_id)[0],
      );

      if (latestAccusedSummon?.id) {
        const assignmentHistoryRes =
          await fetchAccusedAssignmentHistory().catch((err) => {
            if (isNotFoundError(err)) return [];
            throw err;
          });

        setAssignmentHistoryData(
          assignmentHistoryRes?.filter(
            (obj: any) => obj?.summon_appeal === latestAccusedSummon?.id,
          ),
        );
      } else {
        setAssignmentHistoryData([]);
      }
    } catch (err) {
      showToast(t("failedToLoadComplaint"), "error");
    } finally {
      setIsInitialLoading(false);
    }
  };

  const loadComplaints = useCallback(async () => {
    if (!uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchComplaintById(uu_id);
      setComplaintData(
        Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
      );
      // setError("");
    } catch (err) {
      // setError("Failed to load complaint.");
    } finally {
      // setLoading(false);
    }
  }, [uu_id]);

  const loadInvestigations = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchInvestigationByComplaintId(uu_id);
      if (resData) {
        setAllInvestigationData(resData?.slice()?.reverse());
        setInvestigationData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadAccusedSummon = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchAccusedSummonByComplaintId(uu_id);
      if (resData) {
        setAccusedSummonData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.discipline_complain?.toString() === uu_id?.toString() &&
                obj?.is_appeal_to_general_council === false,
            )[0],
        );

        setAccusedSummonDataForGeneralCouncil(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.discipline_complain?.toString() === uu_id?.toString() &&
                obj.is_appeal_to_general_council,
            )[0],
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadAppealLitigation = useCallback(async () => {
    if (!complaintData || !accusedSummonData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");
      if (resData) {
        setAppealLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summonappeal_accusepProsecutor === accusedSummonData?.id,
            ),
        );
        setAppealLitigationDataForGeneralCouncil(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summonappeal_accusepProsecutor ===
                accusedSummonDataForGeneralCouncil?.id,
            ),
        );
      }
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, accusedSummonData]);

  const loadAppealCouncilLitigation = useCallback(async () => {
    if (!accusedSummonData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealCouncilLitigationByAppealSummonId(
        accusedSummonData?.id || "",
      );
      if (resData) {
        setAppealCouncilLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summonappeal_accusepProsecutor === accusedSummonData?.id,
            ),
        );

        setAppealCouncilLitigationDataForGeneralCouncil(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summonappeal_accusepProsecutor ===
                accusedSummonDataForGeneralCouncil?.id,
            ),
        );
      }
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [accusedSummonData]);

  const loadCourtAppeal = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchCourtAppealByComplaintId(uu_id);
      if (resData) {
        setCourtAppealData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter((obj) => obj.discipline_complain === uu_id)[0],
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  useEffect(() => {
    loadInitialPageData();
  }, [uu_id]);

  const handleSendToRegistrarConfirm = async () => {
    if (!accusedSummonData) {
      showToast(t("summonNotFound"), "error");
      return;
    }

    setIsSubmitLoading(true);

    const data = new FormData();

    data.append("status", ACCUSED_COMPLAINT_STATUS.FORWARDED_TO_REGISTRAR);
    if (!Array.isArray(complaintData)) {
      data.append(
        "accused_prosecutor_name",
        `${complaintData?.accused_prosecutor_name || ""}`,
      );
      data.append(
        "user_id_accused_prosecutor_name",
        complaintData?.user_id_accused_prosecutor_name || "",
      );
      data.append(
        "assigned_prosecutor",
        complaintData?.assigned_prosecutor || "",
      );
      data.append(
        "user_id_assigned_prosecutor",
        complaintData?.user_id_assigned_prosecutor || "",
      );
      data.append("admin_unit_id", complaintData?.admin_unit_id || "");
      data.append("org_id", complaintData?.org_id || "");
    }

    const summon_id = accusedSummonData?.id || "";
    const isFormData = true;

    try {
      await editAccusedSummon(data, summon_id, isFormData);

      loadAccusedSummon();
      showToast(t("successfullyConfirmed"), "success");
      setIsSendToRegistrar(false);
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleSendToCouncilConfirm = async () => {
    if (!accusedSummonData) {
      showToast(t("summonNotFound"), "error");
      return;
    }

    setIsSubmitLoading(true);

    const data = new FormData();

    data.append("status", ACCUSED_COMPLAINT_STATUS.FORWARDED_TO_COUNCIL_OFFICE);
    if (!Array.isArray(complaintData)) {
      data.append(
        "accused_prosecutor_name",
        `${complaintData?.accused_prosecutor_name || ""}`,
      );
      data.append(
        "user_id_accused_prosecutor_name",
        complaintData?.user_id_accused_prosecutor_name || "",
      );
      data.append(
        "assigned_prosecutor",
        complaintData?.assigned_prosecutor || "",
      );
      data.append(
        "user_id_assigned_prosecutor",
        complaintData?.user_id_assigned_prosecutor || "",
      );
      data.append("admin_unit_id", complaintData?.admin_unit_id || "");
      data.append("org_id", complaintData?.org_id || "");
    }

    const summon_id =
      activeTab === tabs[1]
        ? accusedSummonData?.id || ""
        : accusedSummonDataForGeneralCouncil?.id || "";
    const isFormData = true;

    try {
      await editAccusedSummon(data, summon_id, isFormData);

      loadAccusedSummon();
      showToast(t("successfullyConfirmed"), "success");
      setIsSendToCouncil(false);
    } catch (err: any) {
      setIsSubmitLoading(false);
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        <span>💼</span>
        {t("accusedComplaintDetail")}
      </h1>

      <div className="w-full flex flex-wrap items-center justify-between gap-4 mb-5">
        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        {activeTab === tabs[0] && (
          <div className="flex gap-4">
            {/* {canSendAccusedToRegistrar &&
              accusedSummonData?.status === ACCUSED_COMPLAINT_STATUS.APPROVED &&
              !accusedSummonData?.registration_number && (
                <button
                  className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsSendToRegistrar(true)}
                >
                  Send to Registrar
                </button>
              )} */}
          </div>
        )}

        {activeTab === tabs[1] && (
          <div className="flex gap-4">
            {canSendAccusedToRegistrar &&
              accusedSummonData?.status === ACCUSED_COMPLAINT_STATUS.APPROVED &&
              accusedSummonData?.registration_number && (
                <button
                  className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsSendToCouncil(true)}
                >
                  {t("sendToCouncil")}
                </button>
              )}
          </div>
        )}

        {activeTab === tabs[2] && (
          <div className="flex gap-4">
            {
              // accusedSummonData?.status === ACCUSED_COMPLAINT_STATUS.APPROVED &&
              //   accusedSummonData?.registration_number &&

              ((canCreateInspectionDailyHearing &&
                accusedSummonData?.status ===
                  ACCUSED_COMPLAINT_STATUS.FORWARDED_TO_COUNCIL_OFFICE &&
                (!appealLitigationData ||
                  (appealLitigationData &&
                    !appealLitigationData[0]?.is_final_verdict_given))) ||
                (isRegionalWriter &&
                  accusedSummonData?.status ===
                    ACCUSED_COMPLAINT_STATUS.FORWARDED_TO_COUNCIL_OFFICE &&
                  (!appealCouncilLitigationData ||
                    (appealCouncilLitigationData &&
                      !appealCouncilLitigationData[0]
                        ?.is_final_verdict_given)))) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsDailyHearingOpen(true)}
                >
                  {isRegionalWriter && appealCouncilLitigationData?.length === 0
                    ? t("addInitialHearing")
                    : t("addDailyHearing")}
                </button>
              )
            }

            {canCreateLitigationDecision &&
              appealLitigationData &&
              appealLitigationData[0]?.is_final_verdict_given &&
              !appealLitigationData[0]?.council_decision_summary &&
              !appealLitigationData[0]?.council_decision && (
                // councilLitigationData &&
                // councilLitigationData[0]?.is_final_verdict_given &&
                // (councilLitigationData[0]?.council_decision_summary ||
                //   councilLitigationData[0]?.council_decision) &&
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsLitigationDecisionOpen(true)}
                >
                  {t("addAppealLitigationDecision")}
                </button>
              )}

            {isRegionalWriter &&
              appealCouncilLitigationData &&
              appealCouncilLitigationData[0]?.is_final_verdict_given &&
              !appealCouncilLitigationData[0]?.council_decision_summary &&
              !appealCouncilLitigationData[0]?.council_decision && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsCouncilLitigationDecisionOpen(true)}
                >
                  {t("addCouncilOfficeDecision")}
                </button>
              )}

            {/* {isRegionalCouncilHead &&
              !courtAppealData &&
              appealCouncilLitigationData &&
              appealCouncilLitigationData[0]?.is_final_verdict_given &&
              (appealCouncilLitigationData[0]?.council_decision_summary ||
                appealCouncilLitigationData[0]?.council_decision) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() =>
                    setIsCreateAccusedSummonForGeneralCouncilOpen(true)
                  }
                >
                  Create Accused Summon for General Council
                </button>
              )} */}

            {isRegionalCouncilHead &&
              !accusedSummonDataForGeneralCouncil &&
              appealCouncilLitigationData &&
              appealCouncilLitigationData[0]?.is_final_verdict_given &&
              (appealCouncilLitigationData[0]?.council_decision_summary ||
                appealCouncilLitigationData[0]?.council_decision) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() =>
                    setIsCreateAccusedSummonForGeneralCouncilOpen(true)
                  }
                >
                  {t("appealToGeneralCouncil")}
                </button>
              )}

            {/* Inspection Litigation Termination */}
            {canTerminateInspectionLitigation &&
              appealLitigationData &&
              !appealLitigationData[0]?.termination_reason &&
              appealLitigationData[0]?.is_final_verdict_given && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsTerminateOpen(true)}
                >
                  {t("terminate")}
                </button>
              )}

            {/* {canSendAccusedToRegistrar &&
              accusedSummonDataForGeneralCouncil?.status ===
                ACCUSED_COMPLAINT_STATUS.APPROVED &&
              accusedSummonDataForGeneralCouncil?.registration_number && (
                <button
                  className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsSendToCouncil(true)}
                >
                  Send to Council Office
                </button>
              )} */}
          </div>
        )}

        {activeTab === tabs[4] && (
          <div className="flex gap-4">
            {
              // accusedSummonData?.status === ACCUSED_COMPLAINT_STATUS.APPROVED &&
              //   accusedSummonData?.registration_number &&

              ((canCreateInspectionDailyHearing &&
                (!appealLitigationDataForGenralCouncil ||
                  (appealLitigationDataForGenralCouncil &&
                    !appealLitigationDataForGenralCouncil[0]
                      ?.is_final_verdict_given))) ||
                (isRegionalCouncilHead &&
                  (!appealCouncilLitigationDataForGeneralCouncil ||
                    (appealCouncilLitigationDataForGeneralCouncil &&
                      !appealCouncilLitigationDataForGeneralCouncil[0]
                        ?.is_final_verdict_given)))) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsDailyHearingOpen(true)}
                >
                  {isRegionalCouncilHead &&
                  appealCouncilLitigationDataForGeneralCouncil?.length === 0
                    ? t("addInitialHearing")
                    : t("addDailyHearing")}
                </button>
              )
            }

            {canCreateInspectionDailyHearing &&
              appealLitigationDataForGenralCouncil &&
              appealLitigationDataForGenralCouncil[0]?.is_final_verdict_given &&
              !appealLitigationDataForGenralCouncil[0]
                ?.council_decision_summary &&
              !appealLitigationDataForGenralCouncil[0]?.council_decision && (
                // councilLitigationData &&
                // councilLitigationData[0]?.is_final_verdict_given &&
                // (councilLitigationData[0]?.council_decision_summary ||
                //   councilLitigationData[0]?.council_decision) &&
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsLitigationDecisionOpen(true)}
                >
                  {t("addAppealLitigationDecision")}
                </button>
              )}

            {isRegionalCouncilHead &&
              appealCouncilLitigationDataForGeneralCouncil &&
              appealCouncilLitigationDataForGeneralCouncil[0]
                ?.is_final_verdict_given &&
              !appealCouncilLitigationDataForGeneralCouncil[0]
                ?.council_decision_summary &&
              !appealCouncilLitigationDataForGeneralCouncil[0]
                ?.council_decision && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsCouncilLitigationDecisionOpen(true)}
                >
                  {t("addCouncilOfficeDecision")}
                </button>
              )}

            {canAppealToCourt &&
              !courtAppealData &&
              appealCouncilLitigationDataForGeneralCouncil &&
              appealCouncilLitigationDataForGeneralCouncil[0]
                ?.is_final_verdict_given &&
              (appealCouncilLitigationDataForGeneralCouncil[0]
                ?.council_decision_summary ||
                appealCouncilLitigationDataForGeneralCouncil[0]
                  ?.council_decision) && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsAppealCourtOpen(true)}
                >
                  {t("appealToCourt")}
                </button>
              )}
          </div>
        )}
      </div>

      <div className="relative">
        <div
          className={`grid grid-cols-1 lg:grid-cols-3 gap-4 ${
            isInitialLoading ? "pointer-events-none opacity-40" : ""
          }`}
        >
          {/* Detail Info */}
          {activeTab === tabs[0] && (
            <div className="lg:col-span-2 space-y-4">
              {investigationData &&
                complaintData &&
                !Array.isArray(complaintData) &&
                (canViewChargeDoc ||
                  investigationData?.status ===
                    INVESTIGATION_STATUS.FORWARDED_TO_COUNCIL ||
                  investigationData?.status ===
                    INVESTIGATION_STATUS.FORWARDED_TO_HEAD) && (
                  <ChargeDocumentCardAdvocate
                    investigationData={investigationData}
                    complaintData={complaintData}
                    onInvestigationRefresh={loadInvestigations}
                  />
                )}

              {canViewCompliantDetail &&
                complaintData &&
                !Array.isArray(complaintData) &&
                complaintData.status !== COMPLIANT_STATUS?.PENDING && (
                  <DecisionCard
                    complaintData={complaintData}
                    investigationData={investigationData}
                    allInvestigationData={allInvestigationData}
                    onInvestigationRefresh={loadInvestigations}
                  />
                )}

              {canViewCompliantDetail && (
                <ComplaintDetailInfoCard
                  complaintData={complaintData}
                  onComplaintsRefresh={loadComplaints}
                />
              )}
            </div>
          )}

          {/* Litigation */}
          {activeTab === tabs[1] && (
            <div className="lg:col-span-2 space-y-4">
              {canViewAccusedSummon &&
                accusedSummonData &&
                complaintData &&
                !Array.isArray(complaintData) && (
                  <AccusedSummonCard
                    compliantData={complaintData}
                    summonData={accusedSummonData}
                    onSummonRefresh={loadAccusedSummon}
                    onComplaintsRefresh={loadComplaints}
                  />
                )}
            </div>
          )}

          {activeTab === tabs[2] && (
            <div className="lg:col-span-2 space-y-4">
              {appealCouncilLitigationData &&
                appealCouncilLitigationData?.length > 0 && (
                  <AppealCouncilLitigationCard
                    councilLitigationData={appealCouncilLitigationData}
                    onCouncilLitigationRefresh={loadAppealCouncilLitigation}
                  />
                )}

              {appealLitigationData && appealLitigationData?.length > 0 && (
                <AppealLitigationCard
                  litigationData={appealLitigationData}
                  councilLitigationData={appealCouncilLitigationData || []}
                  onLitigationRefresh={loadAppealLitigation}
                />
              )}
            </div>
          )}

          {/* Litigation */}
          {activeTab === tabs[3] && (
            <div className="lg:col-span-2 space-y-4">
              {canViewAccusedSummon &&
                accusedSummonDataForGeneralCouncil &&
                complaintData &&
                !Array.isArray(complaintData) && (
                  <AccusedSummonCard
                    compliantData={complaintData}
                    summonData={accusedSummonDataForGeneralCouncil}
                    onSummonRefresh={loadAccusedSummon}
                    onComplaintsRefresh={loadComplaints}
                  />
                )}
            </div>
          )}

          {/* Litigation */}
          {activeTab === tabs[4] && (
            <div className="lg:col-span-2 space-y-4">
              {appealCouncilLitigationDataForGeneralCouncil &&
                appealCouncilLitigationDataForGeneralCouncil?.length > 0 && (
                  <AppealCouncilLitigationCard
                    councilLitigationData={
                      appealCouncilLitigationDataForGeneralCouncil
                    }
                    onCouncilLitigationRefresh={loadAppealCouncilLitigation}
                  />
                )}

              {appealLitigationDataForGenralCouncil &&
                appealLitigationDataForGenralCouncil?.length > 0 && (
                  <AppealLitigationCard
                    litigationData={appealLitigationDataForGenralCouncil}
                    councilLitigationData={
                      appealCouncilLitigationDataForGeneralCouncil || []
                    }
                    onLitigationRefresh={loadAppealLitigation}
                  />
                )}
            </div>
          )}

          {/* Sidebar */}
          <div className="space-y-4">
            {canViewAssignedHistory && assignmentHistoryData && (
              <AssignedProsecutorHistory
                data={assignmentHistoryData?.map((obj: any) => ({
                  ...obj,
                  assignedTo: obj?.assigned_prosecutor,
                  assignedDate: obj?.assigned_date,
                }))}
              />
            )}
          </div>
        </div>

        {isInitialLoading && (
          <div className="absolute inset-0 z-20 flex justify-center items-start pt-8 rounded-xl bg-gradient-to-br from-white/90 to-red-50/80 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-3 rounded-lg border border-red-100 bg-white/80 px-6 py-5 shadow-sm">
              <div className="h-10 w-10 border-4 border-red-600/80 border-t-transparent rounded-full animate-spin" />
              <p className="text-sm font-semibold text-gray-700">Loading...</p>
            </div>
          </div>
        )}
      </div>

      {/* /////////////////// MODAL FORMS ///////////////////  */}
      {complaintData && !Array.isArray(complaintData) && (
        <AddAccusedDailyHearingModal
          isOpen={isDailyHearingOpen}
          setIsOpen={setIsDailyHearingOpen}
          summonData={
            (activeTab === tabs[2]
              ? accusedSummonData &&
                !Array.isArray(accusedSummonData) &&
                accusedSummonData
              : accusedSummonDataForGeneralCouncil &&
                !Array.isArray(accusedSummonDataForGeneralCouncil) &&
                accusedSummonDataForGeneralCouncil) as AccusedSummon
          }
          complaintData={complaintData}
          onLitigationRefresh={loadAppealLitigation}
          onCouncilLitigationRefresh={loadAppealCouncilLitigation}
        />
      )}

      {complaintData && !Array.isArray(complaintData) && (
        <AddAppealLitigationDecisionModal
          isOpen={isLitigationDecisionOpen}
          setIsOpen={setIsLitigationDecisionOpen}
          complaintData={complaintData}
          litigationData={
            (activeTab === tabs[2]
              ? appealLitigationData && appealLitigationData[0]
              : appealLitigationDataForGenralCouncil &&
                appealLitigationDataForGenralCouncil[0]) as Litigation
          }
          onRefresh={loadAppealLitigation}
        />
      )}

      {appealCouncilLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealCouncilLitigationDecisionModal
            isOpen={isCouncilLitigationDecisionOpen}
            setIsOpen={setIsCouncilLitigationDecisionOpen}
            complaintData={complaintData}
            councilLitigationData={
              (activeTab === tabs[2]
                ? appealCouncilLitigationData && appealCouncilLitigationData[0]
                : appealCouncilLitigationDataForGeneralCouncil &&
                  appealCouncilLitigationDataForGeneralCouncil[0]) as CouncilLitigation
            }
            onRefresh={loadAppealCouncilLitigation}
          />
        )}

      {complaintData &&
        !Array.isArray(complaintData) &&
        appealLitigationData && (
          <TerminateAppealLitigationModal
            isOpen={isTerminateOpen}
            setIsOpen={setIsTerminateOpen}
            litigationData={appealLitigationData[0]}
            complaintData={complaintData}
            onRefresh={loadAppealLitigation}
          />
        )}

      {appealCouncilLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AppealToCourtModal
            isOpen={isAppealCourtOpen}
            setIsOpen={setIsAppealCourtOpen}
            complaintData={complaintData}
            onComplaintRefresh={loadComplaints}
          />
        )}

      {appealLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAccusedSummonModal
            isOpen={isCreateAccusedSummonForGeneralCouncil}
            setIsOpen={setIsCreateAccusedSummonForGeneralCouncilOpen}
            complaintData={complaintData}
            onComplaintRefresh={loadComplaints}
            isAppealToGeneralCouncil={true}
          />
        )}

      <ConfirmationModal
        isOpen={isSendToRegistrar}
        onCancel={() => setIsSendToRegistrar(false)}
        onConfirm={handleSendToRegistrarConfirm}
        isLoading={isSubmitLoading}
      />

      <ConfirmationModal
        isOpen={isSendToCouncil}
        onCancel={() => setIsSendToCouncil(false)}
        onConfirm={handleSendToCouncilConfirm}
        isLoading={isSubmitLoading}
      />
    </div>
  );
}
